/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import summaryStyle from "../summaryStyle";
import Typography from "@mui/material/Typography";
import SummaryDetailsItem from "../../Common/SummaryDetailsItem/SummaryDetailsItem";
import { AbstractCase } from "../../../../types/Entities/AbstractCase";

type CommonAddressProps = {
  product: AbstractCase;
};

const CommonAddress = ({ product }: CommonAddressProps) => {
  return (
    <>
      <Grid sx={summaryStyle.subHeadline} size={12}>
        <Typography variant={"h5"}>Letzte gemeinsame Adresse</Typography>
      </Grid>
      <SummaryDetailsItem caseData={product} fieldPath={"commonAddress.streetAddress"} />
      <SummaryDetailsItem caseData={product} fieldPath={"commonAddress.postalCode"} />
      <SummaryDetailsItem caseData={product} fieldPath={"commonAddress.addressLocality"} />
    </>
  );
};

export default CommonAddress;
